import {Injectable} from '@angular/core';
import {NotificationService} from './notification.service';

import {
    ERROR_CAR_CHANGED,
    ERROR_MATCH_STATE_CHANGED,
    ERROR_ORDER_CAR_NOT_OF_CLIENT,
    ERROR_ORDER_CLIENT_CHANGED,
    ERROR_SHOP_INVOICE_REVISION_CONFLICT
} from './constants';

// The refusals processError shows no toast for, because some screen explains them itself. A caller that does not
// explain one has to say something of its own.
export const SILENT_ERROR_CODES: readonly number[] = [
    102,
    ERROR_MATCH_STATE_CHANGED,
    ERROR_ORDER_CLIENT_CHANGED,
    ERROR_ORDER_CAR_NOT_OF_CLIENT,
    ERROR_CAR_CHANGED
];

const ABC = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

@Injectable()
export class ErrorHandlingService {

    constructor(private notificationService: NotificationService) {
    }

    processError(errorData: any): void {
        switch (errorData.code) {
            case 1:
                this.notificationService.error('text_session_expired');
                break;

            case 102:
                break;

            case 400:
                this.notificationService.error('Bad request');
                break;

            case 409:
                this.notificationService.error('error_report_invalid_format', {
                    row: errorData.data.row + 1,
                    column: ABC[errorData.data.column],
                    msg: errorData.data.msg
                });
                break;

            case 500:
                this.notificationService.error('Internal server error');
                break;

            case 502:
                this.notificationService.error('Bad gateway');
                break;

            // The invoice was revised after the page loaded — by its supplier, or by a repair from its
            // Видаткова — so the write was refused rather than blessing amounts the operator never
            // saw. Says the status did NOT change — the «Приход» page reloads the invoice after this,
            // so the figures on screen become the current ones and the operator can decide again.
            //
            // Since 2026-09-30 the same code also refuses an UN-approval whose approval generation
            // is not the stored one: the invoice was approved again after the page loaded, or the
            // tab predates the panel sending the generation at all (only F5 cures that one — the
            // invoice reload does not). No figures changed in either case; the text is kept as is,
            // by the owner's decision, and «статус не обновлён» still holds.
            case ERROR_SHOP_INVOICE_REVISION_CONFLICT:
                this.notificationService.error('Накладная изменилась — статус не обновлён, проверьте новые данные');
                break;

            // «Вся накладная» and the per-line screen reload the waybill first and then show their own
            // message; a toast here would only flash before it.
            case ERROR_MATCH_STATE_CHANGED:
                break;

            // The screens that set an order's client re-read the order and say what happened themselves.
            case ERROR_ORDER_CLIENT_CHANGED:
            case ERROR_ORDER_CAR_NOT_OF_CLIENT:
                break;

            // The car dialog rereads the car and says what happened itself.
            case ERROR_CAR_CHANGED:
                break;

            default:
                const message = errorData.message ? `: ${errorData.message}` : '';
                
                this.notificationService.error(`Error${message}`);
                break;
        }
    }

}
